import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { BasicTemplateWrapper } from 'src/default/templates'
import { useCrossOrganizationNavigationGuard } from 'src/v2/domains/organization/hooks/useCrossOrganizationNavigationGuard.hook'
import { useAppSelector } from 'src/v2/store/hooks'

import NavigationManager from '@v2/domains/routing/components/NavigationManager'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'

const AppLayout = () => {
  const currentOrganization = useAppSelector(selectCurrentOrganization)
  const location = useLocation()

  const { shouldBlockRendering } = useCrossOrganizationNavigationGuard()

  const isFormBuilder = location.pathname.includes('/form-builder')

  if (shouldBlockRendering) {
    return (
      <>
        <NavigationManager />
      </>
    )
  }

  if (isFormBuilder) {
    return (
      <>
        <NavigationManager />
        <Outlet />
      </>
    )
  }

  return (
    <BasicTemplateWrapper>
      <NavigationManager />
      <Outlet />
    </BasicTemplateWrapper>
  )
}

export default AppLayout
